/* Thanh chip "On this page" cho trang /collections.
 *
 * Viec GHIM do CSS lo (position:sticky tren the boc section) - file nay chi con ba viec:
 *   1. Dung hang chip tu tieu de cac section ben duoi.
 *   2. To sang chip cua section dang xem khi cuon.
 *   3. Bam chip thi cuon toi section do.
 *
 * RANG BUOC CUNG - doc truoc khi sua:
 *   assets/nailhandy-widgets.js co MutationObserver theo doi <body> voi attributeFilter
 *   ['class','open','aria-hidden','hidden','style'] + childList + subtree.
 *   File nay CHI duoc doi: data-nh-state, data-nh-jump-target, aria-current, tabindex.
 *   CAM doi class, style inline, hidden/aria-hidden tren phan tu ben trong <body>.
 *
 *   Chip PHAI la the <a> tran: khong class .button, khong role="button", khong <button>.
 *   nailhandy-widgets.js coi 'main button, main a.button, main [role=button]...' la nut
 *   hanh dong chinh va co the bat body.nailhandy-widget-collision, an sach nut Rewards
 *   lan nut chat.
 */
(function () {
  'use strict';

  var SECTION_SEL = '#MainContent > .shopify-section';
  // Selector tieu de doc tu data-nh-title-selector (05/09/2026: FAQ dung .collapsible-content__heading)
  var DEFAULT_TITLE_SEL = '.collection-list-title';

  function init(nav) {
    if (nav.getAttribute('data-nh-jump-ready')) return;
    nav.setAttribute('data-nh-jump-ready', '1');

    var rail = nav.querySelector('[data-nh-jump-rail]');
    var slot = nav.closest('[data-nh-jump-slot]');
    var max = parseInt(nav.getAttribute('data-nh-max') || '3', 10);
    var TITLE_SEL = nav.getAttribute('data-nh-title-selector') || DEFAULT_TITLE_SEL;
    if (!rail || !slot) return;

    /* ---------------------------------------------------------- 1. gom muc */
    var targets = [];
    var labels = [];
    var sections = [].slice.call(document.querySelectorAll(SECTION_SEL));
    for (var i = 0; i < sections.length && targets.length < max; i++) {
      var sec = sections[i];
      if (sec.contains(nav)) continue;
      if (!sec.offsetHeight) continue;
      var title = sec.querySelector(TITLE_SEL);
      if (!title) continue;
      var text = (title.textContent || '').trim();
      if (!text) continue;
      targets.push(sec);
      labels.push(text);
    }

    // Duoi 2 muc thi mot muc luc khong con y nghia - de nguyen an.
    if (targets.length < 2) return;

    /* -------------------------------------------------- 2. dung hang chip */
    var chips = [];
    targets.forEach(function (sec, idx) {
      sec.setAttribute('data-nh-jump-target', '');
      sec.setAttribute('tabindex', '-1');

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'nh-jump__chip';
      a.href = '#' + sec.id;
      a.textContent = labels[idx];
      li.appendChild(a);
      rail.appendChild(li);
      chips.push(a);

      a.addEventListener('click', function (event) {
        // Khong ghi hash vao URL: id the boc co nhung id theme LIVE ben trong
        // (shopify-section-template--<id>__...), republish la link chet.
        event.preventDefault();
        setActive(idx);
        lock = true;
        // KHONG truyen behavior: de CSS scroll-behavior quyet dinh muot hay khong
        // (base.css dat smooth toan site; khoi prefers-reduced-motion tra ve auto).
        // block:'start' tu ton trong scroll-padding-top.
        sec.scrollIntoView({ block: 'start' });
        waitScrollEnd(function () {
          sec.focus({ preventScroll: true });
        });
      });
    });

    nav.setAttribute('data-nh-state', 'ready');

    /* ------------------------------------------------ 3. muc dang xem */
    var active = -1;

    function setActive(idx) {
      if (idx === active) return;
      if (chips[active]) chips[active].removeAttribute('aria-current');
      if (chips[idx]) chips[idx].setAttribute('aria-current', 'location');
      active = idx;
      centerChip(idx);
    }

    // Tren dien thoai, keo chip dang xem vao giua bang. Dat THANG scrollLeft, khong dung
    // scrollIntoView (no keo theo ca trang = cuop cuon cua khach).
    // Tinh bang toa do THAT: offsetParent cua chip la <nav> chu khong phai rail.
    function centerChip(idx) {
      var chip = chips[idx];
      if (!chip || rail.scrollWidth <= rail.clientWidth + 4) return;
      var cr = chip.getBoundingClientRect();
      var rr = rail.getBoundingClientRect();
      rail.scrollLeft += (cr.left - rr.left) - (rr.width - cr.width) / 2;
    }

    /* -------------------------------------------------- 4. scrollspy hinh hoc
     * KHONG dung IntersectionObserver: section cao ~1000px > khung nhin nen threshold
     * buoc phai la 0, va rootMargin bat bien sau khi tao trong khi chieu cao chong
     * header thay doi (thanh thong bao xuong dong, xoay may). Doc rect TUOI moi lan
     * cuon thi mien nhiem voi ca hai chuyen do. */
    var lock = false;
    var frame = 0;

    function barBottom() {
      var r = slot.getBoundingClientRect();
      return r.bottom + 12;
    }

    function tick() {
      frame = 0;
      if (lock) return;
      var line = barBottom();
      var idx = 0;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].getBoundingClientRect().top <= line) idx = i;
      }
      var maxY = document.documentElement.scrollHeight - window.innerHeight;
      if (window.scrollY >= maxY - 2) idx = targets.length - 1;
      setActive(idx);
      // Da cuon qua het muc cuoi (vd trang FAQ con "Most loved" + "Still stuck?" ben duoi)
      // thi thanh chip khong con viec gi de lam - an di. Chi doi data-nh-state (luat dau file).
      var last = targets[targets.length - 1].getBoundingClientRect();
      var past = last.bottom < line - 12;
      nav.setAttribute('data-nh-state', past ? 'past' : 'ready');
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(tick);
    }

    // Mo khoa khi cu cuon da dung han. scrollend chua co tren Safari cu nen do bang
    // cach scrollY dung yen 3 khung hinh lien tiep - dung hon hen gio cung, vi cu nhay
    // tu cuoi trang len section dau la ~3000px.
    function waitScrollEnd(done) {
      var still = 0;
      var prev = window.scrollY;
      function step() {
        if (window.scrollY === prev) still++;
        else { still = 0; prev = window.scrollY; }
        if (still >= 3) {
          lock = false;
          if (done) done();
          return;
        }
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, function () { lock = false; }, { passive: true });
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    tick();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-nh-jump]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: owner keo tha section thi dung lai tu dau.
  document.addEventListener('shopify:section:load', boot);
})();
